module.exports = {
          srcSet: __webpack_public_path__ + "img/21604a9-4000.jpg"+" 4000w",
          images:[ {path: __webpack_public_path__ + "img/21604a9-4000.jpg",width: 4000,height: 3000}],
          src: __webpack_public_path__ + "img/21604a9-4000.jpg",
          toString:function(){return __webpack_public_path__ + "img/21604a9-4000.jpg"},
          
          width: 4000,
          height: 3000
        }